import { createFilterAtoms } from '@/common/filtering/store.ts';
import {
  DEFAULT_WORK_ORDER_FILTER,
  type WorkOrderFilterDefinition,
} from '@pac/filter/shared/work-orders';
import { resetWorkOrderPaginationOnFilterChangeAtom } from './pagination.ts';

export const workOrderFilterAtoms =
  createFilterAtoms<WorkOrderFilterDefinition>(
    DEFAULT_WORK_ORDER_FILTER,
    resetWorkOrderPaginationOnFilterChangeAtom,
  );
